import { useRef, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import initApp from 'utils/functions/init';
import { contexts } from 'constants/context';
import { status } from 'constants/general';
import { fetchRssFeedList } from 'modules/posts/actions';
import RssFeedView from 'modules/posts/views/RssFeedView';

// ###############################################################
// <------------------------ Constants -------------------------->
// ###############################################################
// ###############################################################
// <---------------------- End Constants ------------------------>
// ###############################################################
const RssFeedPage = () => {
  // ###############################################################
  // <------------------------- Globals --------------------------->
  // ###############################################################
  const { companyProfilesList } = useSelector(state => ({
    companyProfilesList: state.common.companyProfilesList,
  }));

  const dispatch = useDispatch();

  const rssFeedListApiCallBody = useRef({});
  // ###############################################################
  // <----------------------- End Globals ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ useState --------------------------->
  // ###############################################################
  // ###############################################################
  // <---------------------- End useState ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ useEffect -------------------------->
  // ###############################################################
  useEffect(() => {
    initApp(contexts.rssFeed);
  }, []);

  useEffect(() => {
    if (companyProfilesList.status === status.SUCCESS) {
      const body = {
        data: {
          companyKey: sessionStorage.getItem('companyProfileKeyAuthCookie'),
        },
      };
      dispatch(fetchRssFeedList(body));
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [companyProfilesList]);
  // ###############################################################
  // <---------------------- End useEffect ------------------------>
  // ###############################################################
  // ###############################################################
  // <--------------------- rest of hooks ------------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------- End rest of hooks ---------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------------- Logic ---------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ End Logic -------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------- Actions --------------------------->
  // ###############################################################
  // ###############################################################
  // <----------------------- End Actions ------------------------->
  // ###############################################################
  // ###############################################################
  // <----------------------- UI Handlers ------------------------->
  // ###############################################################
  // ###############################################################
  // <--------------------- End UI Handlers ----------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------------- Render --------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ End Render ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------- Return UI ------------------------->
  // ###############################################################
  return <RssFeedView rssFeedListApiCallBody={rssFeedListApiCallBody} />;
  // ###############################################################
  // <----------------------- End Return UI ----------------------->
  // ###############################################################
};

RssFeedPage.propTypes = {};

RssFeedPage.defaultProps = {};

export default RssFeedPage;
